import { InferGetStaticPropsType, NextPage } from 'next';
import { NextSeo } from 'next-seo';

import { ErrorNotFound } from '@/components/Error/ErrorNotFound';
import TopArticles from '@/components/TopArticles';
import { TopArticlesDocument, TopArticlesQuery, TopArticlesQueryVariables } from '@/components/__generated__/TopArticles.generated';
import { NAVIGATION_ITEM_ERROR_NOT_FOUND } from '@/config/constants';
import { createDefaultGetStaticProps } from '@/cutils/page-context/server-side-static-props';
import { envConfigServer } from '@/sconfig/env.server';
import { useTracktor } from 'react-tracktor';

type Props = InferGetStaticPropsType<typeof getStaticProps>;

const Page: NextPage<Props> = () => {
	useTracktor({ pageViewData: { data: NAVIGATION_ITEM_ERROR_NOT_FOUND, event: { type: 'PageViewEvent' } } });

	return (
		<>
			<NextSeo noindex={true} />

			<ErrorNotFound topArticles={<TopArticles />} />
		</>
	);
};

export const getStaticProps = createDefaultGetStaticProps(async (_ctx, apolloClient) => {
	if (apolloClient) {
		// this query prepopulates the apollo cache on the client
		await apolloClient.query<TopArticlesQuery, TopArticlesQueryVariables>({
			query: TopArticlesDocument,
			fetchPolicy: 'cache-first',
		});
	}

	return { props: { navigationTitle: NAVIGATION_ITEM_ERROR_NOT_FOUND.pageTitle }, revalidate: envConfigServer.ERROR_PAGE_TTL };
}, true);

export default Page;
